var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.textContent')}},[_c('el-input',{model:{value:(_vm.optionModel.textContent),callback:function ($$v) {_vm.$set(_vm.optionModel, "textContent", $$v)},expression:"optionModel.textContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }